import { Logger, startGameHub } from 'outpost';
import { GameRoom } from './game-room.ts';
import { Player } from './player.ts';
import { AUTO_LOGIN, AUTO_JOIN } from './constants.ts';

async function main() {
    Logger.configure({ level: 'info' });
    
    startGameHub({
        gameName: 'The Unsummoning',
        gameConstructor: GameRoom,
        playerConstructor: Player,
        autoLogin: AUTO_LOGIN,
        autoJoin: AUTO_JOIN,
        renderer: {
            backgroundColor: 'white',
            fonts: {
                MadimiOne: 'assets/fonts/MadimiOne-Regular.ttf',
            },
            defaultFont: 'MadimiOne',
        },
    });
}

main();